import './bootstrap-vue'
import '@/assets/scss/vendor/main.scss'

export default {}
